/**
 * Access token da sessão — só em memória.
 *
 * Enquanto ele ficava no localStorage, qualquer script da página o lia, e ele
 * sobrevivia ao fechar o navegador. Em memória, o token morre com a aba e um
 * XSS só alcança o que estiver em execução naquele momento. O refresh, que vale
 * muito mais, nem isso: vive num cookie httpOnly que o JavaScript não enxerga.
 *
 * O preço é recarregar a página não ter mais token à mão — por isso a aplicação
 * começa renovando a sessão pelo cookie (`useSessionBootstrap`), e o interceptor
 * cobre qualquer requisição que saia antes disso.
 */
let accessToken: string | null = null

export const getAccessToken = (): string | null => accessToken

export const setAccessToken = (token: string | null) => {
    accessToken = token
}

export const clearAccessToken = () => {
    accessToken = null
}
